import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#ehegattenunterhalt

	{
        "antragstellerIds": [ String ],
        "betragMonatlich": BigDecimal
    }


*/
export const schemaEuropaceUpdateEhegattenunterhalt = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    betragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateEhegattenunterhalt = z.infer<typeof schemaEuropaceUpdateEhegattenunterhalt>;
